export class BrowserClock {
    #clearTimer;
    #now;
    #setTimer;
    constructor(options = {}) {
        this.#clearTimer = options.clearTimer ?? ((handle) => {
            globalThis.clearTimeout(handle);
        });
        this.#now = options.now ?? (() => new Date());
        this.#setTimer = options.setTimer ?? ((callback, delayMs) => globalThis.setTimeout(callback, delayMs));
    }
    now() {
        return this.#now().toISOString();
    }
    wakeAt(dueAt, wake) {
        const delay = Date.parse(dueAt) - this.#now().getTime();
        const handle = this.#setTimer(wake, Number.isFinite(delay) ? Math.max(0, delay) : 0);
        return { cancel: () => this.#clearTimer(handle) };
    }
}
//# sourceMappingURL=browser-clock.js.map